// @flow
import TariffModal from './TariffModal';

export default TariffModal;
